import { render, staticRenderFns } from "./salaryUnique.vue?vue&type=template&id=eca34c06"
import script from "./salaryUnique.vue?vue&type=script&lang=js"
export * from "./salaryUnique.vue?vue&type=script&lang=js"
import style0 from "./salaryUnique.vue?vue&type=style&index=0&id=eca34c06&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports